import { ColoursObj, TicketIcon } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useFormatValue } from '../../hooks/useFormatValue'
import { useObjectContext } from '../providers/objectProvider'
import { CardText } from '../subComponents/cardText'

interface IFlightTimesProps {
    originTime?: string
    originAirportABR?: string
    duration?: string
    destinationTime?: string
    destinationAirportABR?: string
    timeVariant?: string
    abrVariant?: string
    gap?: string
    withDates?: boolean
}

export const FlightTimes = ({
    originAirportABR,
    originTime,
    destinationTime,
    destinationAirportABR,
    timeVariant = 'bodySubtext',
    abrVariant = 'bodyRegular',
    gap = '0px',
    withDates = false,
}: IFlightTimesProps) => {
    const { formatValue } = useFormatValue()
    const { past } = useObjectContext()

    return (
        <Stack gap={gap}>
            <Stack justifyContent={'space-between'} direction={'row'}>
                <CardText
                    alignContent={'center'}
                    component={'p'}
                    variant={abrVariant as any}
                >
                    {originAirportABR}
                </CardText>
                <TicketIcon
                    iconColour={
                        past
                            ? ColoursObj.shades.shade2
                            : ColoursObj.core.secondary
                    }
                    name="Flight_Side"
                />
                <CardText
                    alignContent={'center'}
                    component={'p'}
                    variant={abrVariant as any}
                    textAlign={'end'}
                >
                    {destinationAirportABR}
                </CardText>
            </Stack>
            {withDates && (
                <Stack justifyContent={'space-between'} direction={'row'}>
                    <CardText
                        alignContent={'center'}
                        component={'p'}
                        variant={'bodySubtext'}
                    >
                        {formatValue(originTime ?? '', 'TF;dd-MM-yyyy')}
                    </CardText>

                    <CardText
                        alignContent={'center'}
                        component={'p'}
                        variant={'bodySubtext'}
                        textAlign={'end'}
                    >
                        {formatValue(destinationTime ?? '', 'TF;dd-MM-yyyy')}
                    </CardText>
                </Stack>
            )}
            <Stack justifyContent={'space-between'} direction={'row'}>
                <CardText variant={timeVariant as any}>
                    {formatValue(originTime ?? '', 'time')}
                </CardText>
                <CardText variant="bodySubtext" textAlign={'center'}>
                    {formatValue(originTime ?? '', 'timeDifferenceV2', [
                        destinationTime ?? '',
                    ])}
                </CardText>
                <CardText
                    component={'p'}
                    variant={timeVariant as any}
                    textAlign={'end'}
                >
                    {formatValue(destinationTime ?? '', 'time')}
                </CardText>
            </Stack>
        </Stack>
    )
}
